import React, {Component} from 'react'
import {Button, Dimmer, Icon, Loader, Modal, Radio, Table} from 'semantic-ui-react'
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'
import _ from 'lodash'
import {connect} from "react-redux";
import { updateLockSections} from "../../redux/modules/payReports";
import ListOfLockedProvidersModal from "./ListOfLockedProvidersModal";

class LockHistoryModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
          column: null,
          order: true,
          data: []
        }
       }

    updateLockComponents = (iProps) => {
        const { dispatch } = this.props
        dispatch(updateLockSections(iProps))
            .then(()=>{
                this.props.hideLockedProvidersModal()
            })
    }

    handleSort = clickedColumn => () => {
        const { column, data, order } = this.state
    
        if (column !== clickedColumn) {
          this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            order: true,
          })
    
          return
        }
    
        this.setState({
          data: data.reverse(),
          order: !order
        })
      }

    getTableRows = (lockLogs) => {

        const {showLockedProvidersModal,toggleActiveLock} = this.props;

        let returnArray = [];
        if(lockLogs && lockLogs.length) {

            lockLogs.forEach( (item, lockId) => {
                returnArray.push(
                    <Table.Row key={lockId}>
                        <Table.Cell>
                                <Radio toggle checked={item.lockStatus} onChange={()=>toggleActiveLock(item)}/>
                        </Table.Cell>
                        <Table.Cell><b>{item.data.Key }</b></Table.Cell>
                        <Table.Cell>
                            <Button
                                onClick={()=>showLockedProvidersModal(item)}
                                content="Click to view"
                                className={"primaryColor"}
                            />
                        </Table.Cell>
                        <Table.Cell>{ moment(item.createdAt).format( 'YYYY-MM-DD hh-mm-ss')}</Table.Cell>
                        <Table.Cell><a href={item.data.Location} target={"_blank"}>Link</a></Table.Cell>
                        <Table.Cell> {<Radio checked={item.merge} toggle onChange={()=>toggleActiveLock(item, 'merge')} />}</Table.Cell>
                    </Table.Row>
                );
            });
            return <tbody>{returnArray}</tbody>
        } else {
            return (
                <tbody>
                <tr>
                    <td colSpan="4">No Record Found</td>
                </tr>
                </tbody>
            );
        }

    }

    getModalContent = (lockedProvidersModalData) => {
        if(lockedProvidersModalData.length > 0 && this.state.data.length === 0){
            this.setState({data: lockedProvidersModalData});
        }

        const {profile,notes,schedule,id} =  this.props.selectedLock
        const s3LockDetails = this.props.selectedLock.data
        const {data} = this.state;
        const {startDate ,endDate } =  this.props;

        const updateLockProps = {startDate,endDate, s3LockDetails, id}
        const lockedProvidersArray = lockedProvidersModalData.map(iProvider=>iProvider.provider)

        return data.map((provider, key)=>{

            const isProviderLocked = lockedProvidersArray.map(iProvider=>iProvider.toLocaleUpperCase()).indexOf(provider.provider.toLocaleUpperCase())

            const isScheduleLocked = schedule && schedule
                .split(',')
                .map(iProvider=>iProvider.toLocaleUpperCase()).indexOf(provider.provider.toLocaleUpperCase())

            const isProfileLocked  = profile && profile
                .split(',')
                .map(iProvider=>iProvider.toLocaleUpperCase()).indexOf(provider.provider.toLocaleUpperCase())

            const isNotesLocked = notes && notes
                .split(',')
                .map(iProvider=>iProvider.toLocaleUpperCase()).indexOf(provider.provider.toLocaleUpperCase())
            
            return(<Table.Row key={key}>
                <Table.Cell>
                    {provider.provider}
                </Table.Cell>
                <Table.Cell>
                    {provider.firstName}
                </Table.Cell>
                <Table.Cell>
                    {provider.lastName}
                </Table.Cell>
                <Table.Cell>
                    <Icon.Group size='large'>
                         <span onClick={()=>this.updateLockComponents({
                             provider,
                             locked: isProviderLocked,
                             section: 'care',
                             ...updateLockProps
                         })}>
                            <Icon size='big' color='grey' name='database' />
                            <Icon corner='bottom right' color={isProviderLocked === -1 ? 'green':'red'} name={ isProviderLocked >= 0 ?'lock': 'lock open'} />
                         </span>
                    </Icon.Group>
                </Table.Cell>
                <Table.Cell>
                    <Icon.Group size='large'>
                        <span onClick={()=>this.updateLockComponents({
                            provider,
                            locked:isProfileLocked,
                            section:'profile',
                            ...updateLockProps
                        })}>
                            <Icon size='big' color='grey' name='user doctor' />
                            <Icon corner='bottom right' color={isProfileLocked === -1 ? 'green':'red'} name={ isProfileLocked >= 0 ?'lock': 'lock open'} />
                        </span>

                    </Icon.Group>
                </Table.Cell>
                <Table.Cell>
                    <Icon.Group size='large'>
                        <span onClick={()=>this.updateLockComponents({
                            provider,
                            locked:isNotesLocked,
                            section:'notes',
                            ...updateLockProps
                        })}>
                            <Icon size='big' color='grey' name='money bill alternate' />
                            <Icon size='small' corner='top left' color={isNotesLocked === -1 ? 'green':'red'} name={ isNotesLocked >= 0 ?'lock': 'lock open'} />
                        </span>
                    </Icon.Group>
                </Table.Cell>
                <Table.Cell>
                    <Icon.Group size='large'>
                        <span onClick={()=>this.updateLockComponents({
                            provider,
                            locked:isScheduleLocked,
                            section:'schedule',
                            ...updateLockProps
                        })}>
                            <Icon size='big' color='grey' name='calendar alternate' />
                            <Icon size='small' corner='top left' color={isScheduleLocked === -1 ? 'green':'red'} name={ isScheduleLocked >= 0 ?'lock': 'lock open'} />
                        </span>
                    </Icon.Group>
                </Table.Cell>
            </Table.Row>)
        });
    }

    render() {
        const {lockedProvidersModal, hideLockedProvidersModal, lockedProvidersModalData } = this.props;
        const modalContent = lockedProvidersModal ? this.getModalContent(lockedProvidersModalData) : [];
        const { column, order } = this.state;
        const direction = order ? 'down' : 'up';
        return(<span>
            <Modal
                trigger={<Button>Scrolling Content Modal</Button>}
                open={true}
                size='large'
                onClose={this.props.hideHistoryModal}
                centered={false}
                style = {{ overflow: 'auto' }}
                closeIcon
            >
                <Modal.Header>Lock Logs History {this.props.loadLockHistory ?
                    <Dimmer active>
                        <Loader size='mini'>Loading</Loader>
                    </Dimmer>: ''}
                </Modal.Header>
                <Modal.Content scrolling>

                        <div className="table-responsive overflow-unset">
                            <Table celled className="table table-striped table-hover TableHeaderFixed my-0">
                                <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Active Lock:</Table.HeaderCell>
                                    <Table.HeaderCell>Name</Table.HeaderCell>
                                    <Table.HeaderCell>Locked Providers</Table.HeaderCell>
                                    <Table.HeaderCell>Date Created</Table.HeaderCell>
                                    <Table.HeaderCell>S3 File</Table.HeaderCell>
                                    <Table.HeaderCell>Allow Merge</Table.HeaderCell>
                                </Table.Row>
                                </Table.Header>
                                { this.props && this.getTableRows(this.props.lockHistory) }
                            </Table>
                        </div>
                </Modal.Content>
                <ListOfLockedProvidersModal
                    lockedProvidersModalData={lockedProvidersModalData}
                    modalContent={modalContent}
                    hideLockedProvidersModal={hideLockedProvidersModal}
                    column={column}
                    order={order}
                    direction={direction}
                    handleSort={this.handleSort}
                    lockedProvidersModal={lockedProvidersModal}
                />
            </Modal>

        </span>);
    }
}

export default connect(
    state => ({
        lockHistory: state.get('payReports').get('lockHistory'),
        loadLockHistory: state.get('payReports').get('loadLockHistory'),
    }))(LockHistoryModal);
